var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.58333H16.2917V7.66667H11.5V9.58333ZM11.5 15.3333H16.2917V13.4167H11.5V15.3333ZM8.625 10.5417C9.15208 10.5417 9.6033 10.354 9.97865 9.97865C10.354 9.6033 10.5417 9.15208 10.5417 8.625C10.5417 8.09792 10.354 7.6467 9.97865 7.27135C9.6033 6.89601 9.15208 6.70833 8.625 6.70833C8.09792 6.70833 7.6467 6.89601 7.27135 7.27135C6.89601 7.6467 6.70833 8.09792 6.70833 8.625C6.70833 9.15208 6.89601 9.6033 7.27135 9.97865C7.6467 10.354 8.09792 10.5417 8.625 10.5417ZM8.625 16.2917C9.15208 16.2917 9.6033 16.104 9.97865 15.7286C10.354 15.3533 10.5417 14.9021 10.5417 14.375C10.5417 13.8479 10.354 13.3967 9.97865 13.0214C9.6033 12.646 9.15208 12.4583 8.625 12.4583C8.09792 12.4583 7.6467 12.646 7.27135 13.0214C6.89601 13.3967 6.70833 13.8479 6.70833 14.375C6.70833 14.9021 6.89601 15.3533 7.27135 15.7286C7.6467 16.104 8.09792 16.2917 8.625 16.2917ZM4.79167 20.125C4.26458 20.125 3.81337 19.9373 3.43802 19.562C3.06267 19.1866 2.875 18.7354 2.875 18.2083V4.79167C2.875 4.26458 3.06267 3.81337 3.43802 3.43802C3.81337 3.06267 4.26458 2.875 4.79167 2.875H18.2083C18.7354 2.875 19.1866 3.06267 19.562 3.43802C19.9373 3.81337 20.125 4.26458 20.125 4.79167V18.2083C20.125 18.7354 19.9373 19.1866 19.562 19.562C19.1866 19.9373 18.7354 20.125 18.2083 20.125H4.79167Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallot);
export default __webpack_public_path__ + "static/media/ballot.4867df8bf110d9a38b04dedfb739c700.svg";
export { ForwardRef as ReactComponent };